module.exports = __webpack_public_path__ + "img/ezgi-cinarli-profile.436dec98.jpg";